import { cn } from '~/shared/utils/cn';

type PageHeadingProps = React.HTMLAttributes<HTMLHeadingElement> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export function PageHeading({ as: Tag = 'h1', className, ...props }: PageHeadingProps) {
  return (
    <Tag
      {...props}
      className={cn('flex items-center text-2xl font-semibold text-gray-750', className)}
    />
  );
}
